// extracted by mini-css-extract-plugin
export default {"rightBottom":"src-pages-Order-AllOrders-OrderDetail-ParcelProcess-VirtualProduct-css-module__rightBottom--r9v3-"};